import React from 'react';
import { RadialBarChart, RadialBar, Tooltip, Legend } from 'recharts';

// Custom Tooltip Component
const CustomTooltip = ({ active, payload }: any) => {
  if (active && payload && payload.length) {
    return (
      <div
        style={{
          background: '#fff',
          border: '1px solid #ccc',
          padding: '8px',
          borderRadius: '4px',
          fontSize: '14px',
          zIndex: '999',
          opacity: '1',
        }}
      >
        <p>
          {payload[0].payload.name}: <strong>{payload[0].value}</strong>
        </p>
      </div>
    );
  }
  return null;
};

const SimpleRadialBarChart = () => {
  const totalTransactions = {
    closedDeals: 120,
    rentTransactions: 50,
    sellTransactions: 70,
  };

  const data = [
    {
      // name: 'Total Transactions',
      uv: totalTransactions.closedDeals,
      fill: '#89B1C5',
    },
    {
      // name: 'Total Rent Transaction',
      uv: totalTransactions.rentTransactions,
      fill: '#57BDE2',
    },
    {
      // name: 'Total Sale Transaction',
      uv: totalTransactions.sellTransactions,
      fill: '#085CF0',
    },
  ];

  return (
    <>
      <div className="trans_chart_wrap">
        <RadialBarChart
          width={400}
          height={278}
          innerRadius="70%"
          outerRadius="100%"
          data={data}
          startAngle={90}
          endAngle={-270}
        >
          <RadialBar
            dataKey="uv"
            cornerRadius="50%"
            background={{ fill: '#f0f0f0' }}
            strokeWidth={0}
          />
          <Tooltip content={<CustomTooltip />} />
          <Legend
            iconSize={10}
            layout="horizontal"
            verticalAlign="bottom"
            wrapperStyle={{ paddingTop: '20px' }}
          />
        </RadialBarChart>
        <div className="text">
          <h3>{totalTransactions.closedDeals}</h3>
          <p>Total Bookings</p>
        </div>
      </div>

      <ul className="total_trrans">
        <li style={{ '--c_marker': '#89B1C5' } as React.CSSProperties}>
          <p>Total Bookings</p>
          <h4>{totalTransactions.closedDeals}</h4>
        </li>
        <li style={{ '--c_marker': '#57BDE2' } as React.CSSProperties}>
          <p>Total Active Bookings</p>
          <h4>
            {totalTransactions.rentTransactions} (
            {Math.round((totalTransactions.rentTransactions / totalTransactions.closedDeals) * 100)}
            %)
          </h4>
        </li>
        <li style={{ '--c_marker': '#085CF0' } as React.CSSProperties}>
          <p>Total Pending Bookings</p>
          <h4>
            {totalTransactions.sellTransactions} (
            {Math.round((totalTransactions.sellTransactions / totalTransactions.closedDeals) * 100)}
            %)
          </h4>
        </li>
         <li style={{ '--c_marker': '#085CF0' } as React.CSSProperties}>
          <p>Total Completed Bookings</p>
          <h4>
            {totalTransactions.sellTransactions} (
            {Math.round((totalTransactions.sellTransactions / totalTransactions.closedDeals) * 100)}
            %)
          </h4>
        </li>
      </ul>
    </>
  );
};

export default SimpleRadialBarChart;
